import {
  AfterViewInit,
  DestroyRef,
  Directive,
  ElementRef,
  inject,
  input,
  OnChanges,
  OnDestroy,
  output,
  SimpleChanges,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RichEdit } from 'devexpress-richedit';
import { DataMode } from '../helpers/enums/data-mode.enum';
import { RichEditorService } from '../services/rich-editor.service';

@Directive({
  standalone: false,
  selector: '[gstarRichEditor]',
})
export class RichEditorDirective
  implements AfterViewInit, OnDestroy, OnChanges
{
  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly richEditor = inject(RichEditorService);
  private readonly destroyRef = inject(DestroyRef);

  loaded = output<RichEdit | undefined>();

  fileName = input.required<string>();
  content = input.required<string>();
  mode = input.required<DataMode>();

  constructor() {
    this.richEditor.onDocumentLoaded$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((richEditor: RichEdit | undefined) => {
        this.loaded.emit(richEditor);
      });
  }

  ngAfterViewInit(): void {
    this.init();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['content'] && changes['content'].currentValue) {
      this.richEditor.setFile(this.content(), this.fileName());
    }
  }

  ngOnDestroy(): void {
    this.richEditor.destroy();
  }

  private init(): void {
    this.richEditor.loadSpellcheck().subscribe(() => {
      this.richEditor
        .buildEditor(this.element.nativeElement, this.mode())
        .setFile(this.content(), this.fileName());
    });
  }
}
